module.exports = __webpack_public_path__ + "img/sound-on.cd424c72.svg";